import { createContext } from 'react';
import { ApiSettings, createApiSettings } from '../../api/apiSettings';

export const ApiSettingsContext = createContext<ApiSettings>(
  createApiSettings('/mockUrl'),
);
